const ModalDialogTheme = {
  wrapper:
    "flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50",
};

export default ModalDialogTheme;
